module.exports = __webpack_public_path__ + "img/second-place.2.a077ce9.png";